export default __webpack_public_path__ + "static/media/scatter.a2370873.svg";